// Auth
export const postLogin = `${process.env.VUE_APP_AUTH_API_URL}Token`;
export const logout = `${process.env.VUE_APP_AUTH_API_URL}api/account/Signout`;
export const refreshToken = `${process.env.VUE_APP_AUTH_API_URL}RefreshToken`;
export const requestForgetPassword = `${process.env.VUE_APP_AUTH_API_URL}api/account/RequestChangePassword`;
export const updateUserPassword = `${process.env.VUE_APP_AUTH_API_URL}api/account/UpdateUserPassword`;
export const resetMFA = `${process.env.VUE_APP_AUTH_API_URL}api/account/ResetMySecurityStamp`;

// Base

// AAA
export const getAccountDetail = "AAA/GetAccountDetail";
export const updateMyAccount = "AAA/UpdateMyAccount";
export const querySimpleAccount = "AAA/QueryAccountsSimplyInfo";
export const querySimpleAccountTree = "AAA/QueryAccountsSimplyInfoTree";
export const queryAccounts = "AAA/QueryAccounts";
export const deleteAccounts = "AAA/DeleteAccounts";
export const queryRoles = "AAA/QueryRoles";
export const deleteRoles = "AAA/DeleteRoles";
export const createAccounts = "AAA/CreateAccounts";
export const updateAccounts = "AAA/UpdateAccounts";
export const getPermissionsMetaData = "AAA/GetPermissionsMetaData";
export const createRoles = "AAA/CreateRoles";
export const getRoleDetail = "AAA/GetRoleDetail";
export const updateRoles = "AAA/UpdateRoles";
export const getAccountImportTemplate = "AAA/GetAccountImportTemplate";
export const checkAccountImportTemplate = "AAA/CheckAccountImportTemplate";
export const updateMySecurityStamp = "AAA/UpdateMySecurityStamp";
export const updateSecurityStamp = "AAA/UpdateSecurityStamp";

// Utility
export const queryParameters = "Utility/QueryParameters";
export const queryDepartments = "Utility/QueryDepartments";
export const querySimpleDepartment = "Utility/QueryDepartmentsSimplyInfo";
export const createDepartments = "Utility/CreateDepartments";
export const updateDepartments = "Utility/UpdateDepartments";
export const deleteDepartments = "Utility/DeleteDepartments";
export const queryDepartmentsSimplyInfoTree =
  "Utility/QueryDepartmentsSimplyInfoTree";
export const getParameterTypes = "Utility/GetParameterTypes";
export const queryParameterTypeParameters =
  "Utility/QueryParameterTypeParameters";
export const deleteParameterTypeParameters =
  "Utility/DeleteParameterTypeParameters";
export const createParameterTypeParameters =
  "Utility/CreateParameterTypeParameters";
export const getParameterTypeParameterDetail =
  "Utility/GetParameterTypeParameterDetail";
export const updateParameterTypeParameters =
  "Utility/UpdateParameterTypeParameters";
export const uploadFile = "Utility/UploadFile";

// Assessment
export const querySubjects = "Assessment/QuerySubjects";
export const querySubjectsByJob = "Assessment/QuerySubjectsByJob";
export const createAssessments = "Assessment/CreateAssessments";
export const deleteSubject = "Assessment/DeleteSubjects";
export const getSubjectDetail = "Assessment/GetSubjectDetail";
export const createSubjectsV2 = "Assessment/CreateSubjectsV2";
export const getVideoAssessmentReport = "Assessment/GetVideoAssessmentReport";
export const getVideoAssessmentReportByToken =
  "Assessment/GetVideoAssessmentReportByToken";
export const updateVideoAssessmentScore =
  "Assessment/UpdateVideoAssessmentScore";
export const notifyAssessmentV2 = "Assessment/NotifyAssessmentsV2";
export const getAssessmentReport = "Assessment/GetAssessmentReport";
export const getAssessmentReportV2 = "Assessment/GetAssessmentReportV2";
export const getAssessmentReportByToken =
  "Assessment/GetAssessmentReportByToken";
export const getAssessmentReportByTokenV2 =
  "Assessment/GetAssessmentReportByTokenV2";
export const querySubjectsSimplyInfoTree =
  "Assessment/QuerySubjectsSimplyInfoTree";
export const reinviteAssessmentV2 = "Assessment/ReinviteAssessmentsV2";
export const deleteAssessmentV2 = "Assessment/DeleteAssessmentsV2";
export const shareAssessmentV2 = "Assessment/ShareAssessmentsReportV2";
export const updateSubjectsV2 = "Assessment/UpdateSubjectsV2";
export const getCatAssessmentImportTemplate =
  "Assessment/GetCATAssessmentImportTemplate";
export const checkCatAssessmentImportTemplate =
  "Assessment/CheckCATAssessmentImportTemplate";
export const getHarrisonAssessmentImportTemplate =
  "Assessment/GetHarrisonAssessmentImportTemplate";
export const checkHarrisonAssessmentImportTemplate =
  "Assessment/CheckHarrisonAssessmentImportTemplate";
export const getDdiAssessmentImportTemplate =
  "Assessment/GetDDIAssessmentImportTemplate";
export const checkDdiAssessmentImportTemplate =
  "Assessment/CheckDDIAssessmentImportTemplate";
export const exportCatRawTemplate = "Assessment/ExportCATRawTemplate";

// Job
export const queryJobs = "Job/QueryJobs";
export const getJobPreviewCode = "Job/GetJobPreviewCode";
export const createJobs = "Job/CreateJobs";
export const deleteJobs = "Job/DeleteJobs";
export const archiveJobs = "Job/ArchiveJobs";
export const copyJobs = "Job/ReplicationJobs";
export const releaseJobs = "Job/PublishJobs";
export const getJobDetail = "Job/GetJobDetail";
export const updateJobs = "Job/UpdateJobs";
export const queryJobSubjects = "Job/QueryJobSubjects";
export const createJobSubjects = "Job/CreateJobSubjects";
export const inviteJobSubjects = "Job/InviteJobSubjects";
export const deleteJobSubjects = "Job/DeleteJobSubjects";
export const queryJobsSimplyInfoTree = "Job/QueryJobsSimplyInfoTree";
export const resumeJobs = "Job/ResumeJobs";
export const getJobAIValuesWeight = "Job/GetJobAIValuesWeight";
export const updateJobAIValuesWeight = "Job/UpdateJobAIValuesWeight";
export const getJob9BoxWeight = "Job/GetJob9BoxWeight";
export const updateJob9BoxWeight = "Job/UpdateJob9BoxWeight";
export const getJobSubjectsImportTemplate = "Job/GetJobSubjectsImportTemplate";
export const checkJobSubjectsImportTemplate =
  "Job/CheckJobSubjectsImportTemplate";
export const queryJobSubjectsFor9Box = "Job/QueryJobSubjectsFor9Box";
export const exportAIRawTemplate = "Job/ExportAIRawTemplate";
export const updateJobSubjectsStatus = "Job/UpdateJobSubjectsStatus";
export const getJobSearchFields = "Job/GetJobSearchFields";

// Exam
export const queryExamsSimplyInfo = "Exam/QueryExamsSimplyInfo";
export const queryExams = "Exam/QueryExams";
export const copyExams = "Exam/ReplicationExams";
export const deleteExams = "Exam/DeleteExams";
export const updateExams = "Exam/UpdateExams";
export const createExams = "Exam/CreateExams";
export const queryExamQuestions = "Exam/QueryExamQuestions";
export const deleteExamQuestions = "Exam/DeleteExamQuestions";
export const copyExamQuestions = "Exam/ReplicationExamQuestions";
export const getExamDetail = "Exam/GetExamDetail";
export const updateExamQuestionsOrder = "Exam/UpdateExamQuestionsOrder";
export const createExamType1Questions = "Exam/CreateExamType1Questions";
export const getExamType1QuestionDetail = "Exam/GetExamType1QuestionDetail";
export const updateExamType1Questions = "Exam/UpdateExamType1Questions";
export const createExamType2Questions = "Exam/CreateExamType2Questions";
export const getExamType2QuestionDetail = "Exam/GetExamType2QuestionDetail";
export const updateExamType2Questions = "Exam/UpdateExamType2Questions";
export const createExamType3Questions = "Exam/CreateExamType3Questions";
export const getExamType3QuestionDetail = "Exam/GetExamType3QuestionDetail";
export const updateExamType3Questions = "Exam/UpdateExamType3Questions";
export const createExamType4Questions = "Exam/CreateExamType4Questions";
export const getExamType4QuestionDetail = "Exam/GetExamType4QuestionDetail";
export const updateExamType4Questions = "Exam/UpdateExamType4Questions";
export const createExamType1QuestionsFromQuestionBank =
  "Exam/CreateExamType1QuestionsFromQuestionBank";
export const queryQuestionFromQuestionBank =
  "Exam/QueryQuestionFromQuestionBank";

// Quota
export const queryQuotas = "Quota/QueryQuotas";
export const getQuotaDetails = "Quota/GetQuotaDetails";
export const getQuotaHistory = "Quota/GetQuotaHistory";
export const checkService = "Quota/CheckService";
export const checkResidual = "Quota/CheckResidual";
export const checkResidualWithPhone = "Quota/CheckResidualWithPhone";
export const checkResidualWithSubjectId = "Quota/CheckResidualWithSubjectId";
